import styled from 'styled-components';

import { lineClamp } from '@xing-com/crate-utils-line-clamp';
import { BodyCopy } from '@xing-com/typography';

export const Container = styled.div<{ lineClampProp: number | null }>`
  ${(props) =>
    props.lineClampProp !== null ? lineClamp(props.lineClampProp) : ''}
  word-break: break-word;
`;

export const HiddenBodyCopy = styled(BodyCopy)`
  pointer-events: none;
  position: absolute;
  visibility: hidden;
  width: 100%;
`;

export const OverflowLabel = styled.b`
  display: none;
  opacity: 0;
  visibility: hidden;
  white-space: nowrap;

  &.visible {
    display: inline;
    opacity: 1;
    visibility: visible;
  }
`;
